class LocalizationMenu extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details.localization');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('[data-mega-menu-content]');
  }

  connectedCallback() {
    if (!this.details || !this.summary) return;

    this.boundSummaryClick = this.handleSummaryClick.bind(this);
    this.boundFocusOut = this.handleFocusOut.bind(this);
    this.boundKeydown = this.handleKeydown.bind(this);
    this.boundDocumentClick = this.handleDocumentClick.bind(this);

    this.summary.addEventListener('click', this.boundSummaryClick);
    this.content?.addEventListener('focusout', this.boundFocusOut);
    document.addEventListener('keydown', this.boundKeydown);
    document.addEventListener('click', this.boundDocumentClick);
  }

  disconnectedCallback() {
    this.summary?.removeEventListener('click', this.boundSummaryClick);
    this.content?.removeEventListener('focusout', this.boundFocusOut);
    document.removeEventListener('keydown', this.boundKeydown);
    document.removeEventListener('click', this.boundDocumentClick);
  }

  handleSummaryClick(e) {
    e.preventDefault();
    this.toggle();
  }

  handleFocusOut(e) {
    if (this.content?.contains(e.relatedTarget)) return;
    this.close();
  }

  handleKeydown(e) {
    if (e.key === 'Escape' && this.details?.classList.contains('open')) {
      this.close();
      this.summary?.focus();
    }
  }

  handleDocumentClick(e) {
    if (this.contains(e.target)) return;
    this.close();
  }

  toggle() {
    if (this.details?.classList.contains('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    if (!this.details) return;
    this.details.open = true;
    this.details.classList.add('open');
    this.closest('[data-localization]')?.classList.add('open');
    document.dispatchEvent(
      new CustomEvent('menu:open', { detail: { context: 'localization' }, bubbles: true })
    );
  }

  close() {
    if (!this.details) return;
    this.details.classList.remove('open');
    this.details.open = false;
    this.closest('[data-localization]')?.classList.remove('open');
  }
}

if (!customElements.get('localization-menu')) {
  customElements.define('localization-menu', LocalizationMenu);
}
 